// @ts-nocheck
import React, { useState, useEffect } from 'react'

// @ts-ignore
type Props = {
  children: React.ReactNode,
  waitBeforeShow?: number,
}

// @ts-ignore
const Delayed = ({ children, waitBeforeShow = 2500 }: Props) => {
  const [isShown, setIsShown] = useState(false)

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsShown(true)
    }, waitBeforeShow)
    return () => clearTimeout(timer)
  }, [waitBeforeShow])

  return isShown ? children : null
}

export default Delayed
